export default __webpack_public_path__ + "static/media/ETH_TURIN__logo111.919e05d1.png";